const colors = {
  primaryBlue: "#3686ff"
}

export default {
  colors
}



// WEBPACK FOOTER //
// ./src/constants.js